import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './pages/About';
import Research from './pages/Research';
import Project from './pages/Project';
import Navbar from './components/Navbar';
import ProjectsViewer from './pages/ProjectsViewer';
import ResearchViewer from './pages/ResearchViewer';
import Blog from './pages/Blog';
import BlogViewer from './pages/BlogViewer';
import Contact from './pages/Contact';
import DefaultsViewer from './pages/DefaultsViewer'
import Music from './pages/Music'

function App() {
  return (
    <>
      <Navbar />
      <hr className='divider'/>
      <div className='App'>
        <Router>
          <Routes>
            <Route path="/" element={<About/>} />
            <Route path="/research" element={<Research/>} />
            <Route path="/project" element={<Project/>} />
            <Route path="/blog" element={<Blog/>} />
            {/* <Route path="/music" element={<Music/>} /> */}
            <Route path="/contact" element={<Contact/>} />
            <Route path="*" element={<div>404 Not Found.</div>} />
            <Route path="/projects/:file" element={<ProjectsViewer />} />
            <Route path="/researches/:file" element={<ResearchViewer />} />
            <Route path="/blogs/:file" element={<BlogViewer />} />
            <Route path="/defaults/:file" element={<DefaultsViewer />} />
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default App;
